import React from "react";
import { Col, Row } from "react-bootstrap";
import "../../assets/styles/smu-preload.scss";
import { BIG_LOGO_LIGHT } from "../../constants/images";
import percentageIcon from "../../assets/images/percentage-icon.png";

const SmuPreload = ({ show }) => {
  return (
    <div className={`smu-preload ${!show ? "d-none" : ""}`}>
      <Row className="mb-5 mt-auto">
        <Col col={12} md={4} className="mx-auto d-flex">
          <img src={BIG_LOGO_LIGHT} alt="Logo" className="mx-auto" />
        </Col>
      </Row>
      <Row className="mt-5 mb-auto">
        <Col col={12} md={4} className="mx-auto d-flex flex-column">
          <img src={percentageIcon} alt="Icon" className="mx-auto" width={48} />
          <h3 className="text-white mt-4 text-center">Portal Promocional</h3>
        </Col>
      </Row>
    </div>
  );
};

export default SmuPreload;
